import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';

export const StyledDialog = styled(Dialog)`
  & div.MuiDialog-paper {
    width: 50rem;
    max-width: 50rem;
  }
`;
